import objectEquals from './objectEquals';
import reduceCartItemProps from './reduceCartItemProps';
import pendingRemovalTimers from './pendingRemovalTimers';

function getCartIdPendingRemoval ({ slug, ...props }) {
  const ids = Object.keys(pendingRemovalTimers);
  return ids.find(id => {
    const pendingItem = pendingRemovalTimers[id];
    return (
      pendingItem.slug === slug &&
      objectEquals(pendingItem.item, reduceCartItemProps(props))
    );
  });
}

export default getCartIdPendingRemoval;



// WEBPACK FOOTER //
// ./src/cart/actions/helpers/getCartIdPendingRemoval.js